export default "__VITE_ASSET__BcYe53OZ__"